import script from "./web-contact-us.vue?vue&type=script&setup=true&lang=js"
export * from "./web-contact-us.vue?vue&type=script&setup=true&lang=js"

import "./web-contact-us.vue?vue&type=style&index=0&id=4d1b586a&lang=scss"

const __exports__ = script;

export default __exports__